<!-- Table -->
<div class="table-responsive" *ngIf="(matches$ | async)?.length">
  <table class="table table-borderless table-nowrap table-hover">
    <thead class="table-light">
      <tr>
        <th scope="col">{{ 'general.date' | translate }}</th>
        <th scope="col">{{ 'competitionModule.teams' | translate }}</th>
        <th scope="col">{{ 'competitionModule.result' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let match of matches$ | async">
        <td>
          {{
            (bookingEntities$ | async)[match.bookingId]?.startDate
              | formatDate : 'd MMM y'
              | async
          }}
          {{
            (bookingEntities$ | async)[match.bookingId]?.startDate
              | date : 'HH:mm'
          }}
        </td>
        <td>
          <span [class]="match?.team1Score > match?.team2Score ? 'fw-bold' : ''"
            >{{
              (competitionTeamEntities$ | async)[match.team1Id]?.description
            }}
          </span>
          -
          <span [class]="match?.team2Score > match?.team1Score ? 'fw-bold' : ''"
            >{{
              (competitionTeamEntities$ | async)[match.team2Id]?.description
            }}
          </span>
        </td>
        <td>{{ match?.team1Score }} - {{ match?.team2Score }}</td>
      </tr>
    </tbody>
  </table>
</div>
<!-- End Table -->
<div *ngIf="!(matches$ | async)?.length && !(isLoading$ | async)" class="p-4">
  <span *ngIf="!competitionId">{{
    'competitionModule.teamHasNoCompletedMatches' | translate
  }}</span>
  <span *ngIf="competitionId">{{
    'competitionModule.competitionHasNoCompletedMatches' | translate
  }}</span>
</div>
